<template>
    <div class="card select-a-dealer__card">
        <div class="card__inner select-dealer-card">
            <div class="select-dealer-card__address">
                <h3 class="select-dealer-card__title">Dealer Address</h3>
                <p class="select-dealer-card__info">
                    {{ nameParts.first }} <br />
                    <strong v-if="nameParts.last">{{ nameParts.last }}</strong> <br />
                    {{ dealer.address }}<br />
                    {{ dealer.postcode }}
                </p>
            </div>

            <div class="select-dealer-card__logo">
                <picture v-if="dealer.brand == 'abarth' && !isTakataRecallFixDealer">
                    <source type="image/webp" :srcset="`/img/logos/borderless/${dealer.brand}.webp, /img/logos/borderless/${dealer.brand}@2x.webp 2x`">
                    <img class="img-responsive" :src="`/img/logos/borderless/${dealer.brand}.jpg, /img/logos/borderless/${dealer.brand}@2x.jpg 2x`" :alt="dealer.brand">
                </picture>
                <img v-else-if="!isTakataRecallFixDealer" class="img-responsive" :src="brandLogoPath(`/img/logos/borderless/${dealer.brand}.svg`)" :alt="dealer.brand" />
            </div>

            <!-- Add a nicely formatted notice -->
            <div v-if="isTakataRecallFixDealer" class="select-dealer-card__notice">
                <p class="select-dealer-card__notice-text">This Peugeot site is helping to support the Vauxhall Takata recall, to get your vehicle seen sooner.</p>
            </div>

            <button type="button" class="btn btn--primary-inverted select-dealer-card__cta" :class="{'select-dealer-card__cta--has-notice': isTakataRecallFixDealer}" :disabled="unavailable" @click="selectDealer">
                {{ unavailable ? 'No availability' : 'Select this dealer' }}
            </button>
        </div>
    </div>
</template>

<script>
import brandLogoPath from '../../../modules/brandLogoPath';
export default {
    name: 'DealerCard',
    props: {
        unavailable: { type: Boolean, default: false },
        dealer: {
            type: Object,
            required: true,
        },
        takataRecallDealers: {
            type: Array,
            required: false,
            default: () => []
        }
    },
    computed: {
        isTakataRecallFixDealer() {
            return this.takataRecallDealers.includes(this.dealer.id);
        },

        nameParts() {
            const rawName = (this.dealer && this.dealer.name) ? String(this.dealer.name).trim() : '';
            if (!rawName) return { first: '', last: '' };

            // Known Stellantis brands (including multi-word brands)
            const brands = [
                'Alfa Romeo', 'Abarth', 'Citroën', 'Citroen', 'DS', 'Peugeot', 'Parts', 'Vauxhall', 'Fiat', 'Jeep', 'UK', 'Leapmotor'
            ];

            // Escape for use in regex
            const escapeRegExp = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            const brandPattern = brands.map(b => escapeRegExp(b)).join('|');

            // Match: everything up to and including the brand, then optional tail (location/extra)
            const re = new RegExp('^(.*?Stellantis &You(?:\\s+(?:' + brandPattern + ')))\\b(?:\\s+(.*))?$', 'i');
            const m = rawName.match(re);
            if (m) {
                let first = m[1].trim();
                let tail = (m[2] || '').trim();

                // If tail begins with the word 'Store', drop it (e.g. 'DS Store Coventry' -> tail 'Coventry')
                tail = tail.replace(/^store\b\s*/i, '');

                return { first, last: tail };
            }

            // Fallback: split last token as city
            const tokens = rawName.split(/\s+/).filter(Boolean);
            if (tokens.length <= 1) return { first: rawName, last: '' };
            const last = tokens.slice(-2).join(' ');
            const first = tokens.slice(0, -2).join(' ');
            // If taking last two tokens makes no sense (first empty), fall back to single-token city
            if (!first) {
                return { first: tokens.slice(0, -1).join(' '), last: tokens.slice(-1).join(' ') };
            }
            return { first: first.trim(), last: last.trim() };
        }
    },
    methods: {
        brandLogoPath,
        selectDealer() {
            if (!this.unavailable) {
                this.$emit('select', this.dealer);
            }
        }
    }
}
</script>
